module.exports = __webpack_public_path__ + "static/media/20.de7ccc38.jpg";